/**
 * Cỡ hiển thị logo cổng truy cập.
 *
 * Admin chỉ khai báo MỘT con số — chiều cao logo ở trang đăng nhập. Cỡ trên
 * TopBar được suy ra rồi chặn trần, cố ý không cho đặt tay: Toolbar mặc định
 * của MUI cao 64px, một giá trị quá lớn sẽ đội vỡ thanh điều hướng ở mọi trang.
 */

/** Cỡ logo trang đăng nhập khi cổng chưa khai báo — đúng cỡ gán cứng trước đây. */
export const DEFAULT_LOGO_HEIGHT = 56;

/**
 * Khoảng cỡ hợp lệ. PHẢI khớp LOGO_HEIGHT_MIN/MAX trong apps/api/src/routes/
 * portals.ts — lệch thì thanh trượt cho chọn giá trị mà API trả 400.
 */
export const LOGO_HEIGHT_MIN = 40;
export const LOGO_HEIGHT_MAX = 140;

/** Trần cỡ logo trên TopBar, chừa chỗ cho Toolbar 64px. */
const TOP_BAR_MAX = 40;

/** Chiều cao logo hợp lệ cho trang đăng nhập; giá trị rác → cỡ mặc định. */
export function loginLogoHeight(raw?: number | null): number {
  if (typeof raw !== 'number' || !Number.isFinite(raw) || raw <= 0) return DEFAULT_LOGO_HEIGHT;
  return raw;
}

/** Chiều cao logo trên TopBar: nửa cỡ trang đăng nhập, không vượt 40px. */
export function topBarLogoHeight(raw?: number | null): number {
  return Math.min(Math.round(loginLogoHeight(raw) / 2), TOP_BAR_MAX);
}
